import React from 'react';
import T from 'prop-types';
import { friendlyErrorMessage } from 'app/utils/parsers';
import Alert from 'app/components/general/Alert';
import { Card, CardBody, Form } from 'reactstrap';
import Button from 'app/components/general/Button';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import history from 'app/routes/history';

export default class BankDetails extends React.Component {
  static propTypes = {
    actions: T.shape({
      createBankAccount: T.func.isRequired,
      updateAdminData: T.func.isRequired,
    }),
    isLoading: T.bool,
    account: T.shape({
      name: T.string,
      bsb: T.string,
      number: T.string,
      bank: T.string,
    }),
    backendErrors: T.object,
  };

  static defaultProps = {
    isLoading: false,
    backendErrors: {},
    actions: undefined,
    account: undefined,
  };

  state = {
    name: this.props.account.name || '',
    bsb: this.props.account.bsb || '',
    number: this.props.account.number || '',
    bank: this.props.account.bank || '',
    backendErrors: this.props.backendErrors || {},
    errors: [],
  };

  componentWillReceiveProps(newProps) {
    if (newProps.backendErrors !== this.props.backendErrors) {
      this.setState({ backendErrors: newProps.backendErrors });
    }
  }

  handleChange = (e) => {
    delete this.state.errors[e.target.name];
    this.setState({ backendErrors: {} });

    const state = {
      [e.target.name]: e.target.value,
      errors: this.state.errors,
    };
    this.setState(state);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.name && this.state.bsb && this.state.number) {
      this.props.actions.createBankAccount({
        name: this.state.name,
        bsb: this.state.bsb,
        number: this.state.number,
        bank: this.state.bank,
      });
    } else {
      history.push('/my-team');
    }
  };

  renderBackendErrors(): React.ReactNode {
    if (
      !_.isEmpty(this.state.backendErrors?.message)
    ) {
      return (
        <Alert color="error">
          {friendlyErrorMessage(this.state.backendErrors.message)}
        </Alert>
      );
    }
    return null;
  }

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <Card className="extra-shadow">
              <CardBody className="with-extra-padding-2">
                <div className="row">
                  <div className="col">
                    <h2>
                      Provide your bank details (Optional)
                    </h2>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <span className="text-caption text-grey">
                      You can do this at a later time, but is needed if collecting payments.
                    </span>
                  </div>
                </div>
                <div className="row with-margin-top">
                  <div className="col">
                    {this.renderBackendErrors()}
                    <Form onSubmit={this.handleSubmit}>
                      <div className="row">
                        <div className="col-12">
                          <InputGroupBlock
                            type="text"
                            name="name"
                            labelText="Account Holder Name"
                            placeholder="Account Name"
                            aria-label="Account Name"
                            autoFocus
                            autoComplete="off"
                            tabIndex="1"
                            value={this.state.name}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12 col-md-5">
                          <InputGroupBlock
                            type="text"
                            name="bsb"
                            labelText="BSB"
                            placeholder="BSB"
                            aria-label="BSB"
                            autoComplete="off"
                            tabIndex="2"
                            value={this.state.bsb}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="col-12 col-md-7">
                          <InputGroupBlock
                            type="text"
                            name="number"
                            labelText="Account Number"
                            placeholder="Account Number"
                            aria-label="Account Number"
                            autoComplete="off"
                            tabIndex="3"
                            value={this.state.number}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <InputGroupBlock
                            type="text"
                            name="bank"
                            labelText="Bank Name"
                            placeholder="Bank Name"
                            aria-label="Bank Name"
                            autoComplete="off"
                            tabIndex="4"
                            value={this.state.bank}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <Button
                            className="btn-1 btn-full-width success-sm"
                            color="primary"
                            tabIndex="5"
                            isLoading={this.props.isLoading}
                            type="submit"
                          >
                            {this.state.name && this.state.bsb && this.state.number
                              ? 'Create bank account'
                              : 'Continue to dashboard'}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}
